import { H3HexagonLayer } from "@deck.gl/geo-layers";
import type { GeoJSON } from "geojson";

import { initGeoJsonLayer } from "./initGeoJsonLayer";

export const initAreaViewLayer = (areaH3IndexData: string[], geometry: GeoJSON | null) =>
  areaH3IndexData.length > 0
    ? new H3HexagonLayer({
        id: "h3-area-view-layer",
        data: areaH3IndexData,
        pickable: true,
        wireframe: true,
        filled: true,
        extruded: true,
        elevationScale: 0,
        autoHighlight: false,
        getHexagon: (d) => d,
        getFillColor: (_d) => [239, 134, 209, 190],
      })
    : initGeoJsonLayer(geometry);
